import * as Cookies from 'es-cookie';
import { getStoreBuilder,BareActionContext } from "vuex-typex";
import { RootState,PorterBuilderState } from "../types";
import { GetPorterItemListViewModel, GetPorterViewModel, Client, CreatePorterItemCommandArguments, Porter, UpdatePorterItemCommandArguments, DeletePorterItemCommandArguments, PorterItemViewModel } from "Api/CoreApi";
import ApiProvider from 'Api/ApiProvider';
const initialPorterBuilderState: PorterBuilderState = {
    porterId: "",
    porter: undefined,
    porterItems: new GetPorterItemListViewModel({porterItems: []}),
    languageId: "",
    isLoading: false,
    error: false,
    modalItemNo: ""
};

const p = getStoreBuilder<RootState>().module("porterBuilder", initialPorterBuilderState);

//Mutations
function setPorterId(state:PorterBuilderState,porterId:string){
    state.porterId = porterId;
}
function setLanguageId(state:PorterBuilderState, languageId:string) {
    state.languageId = languageId;
}
function porterItemsLoading(state:PorterBuilderState) {
    state.isLoading = true;
}
function porterItemsLoaded(state:PorterBuilderState, porterItems:GetPorterItemListViewModel) {
    state.error = false;
    state.isLoading = false;
    state.porterItems = porterItems;
}
function porterError(state:PorterBuilderState, error:string) {
    state.isLoading = false;
    state.error = true;
}
function initializePorter(state:PorterBuilderState, porter:GetPorterViewModel) {
    state.porter = porter;
}
function clearPorter(state:PorterBuilderState) {
    state.porter = undefined;
    state.porterId = undefined;
    state.porterItems = undefined;
}
function setModalItemNumber(state:PorterBuilderState, itemNo:string) {
    state.modalItemNo = itemNo;
}
function clearModalItemNumber(state:PorterBuilderState) {
    state.modalItemNo = undefined;
}

//Actions
async function setPorterIdAction(context:BareActionContext<PorterBuilderState,RootState>, porterId: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Cookies.set("PorterBuilderId", porterId, null);
        porterBuilder.commitSetPorterId(porterId);
        resolve();
    });
}

var loadPromise : Promise<any>;
async function loadPorterItems(context:BareActionContext<PorterBuilderState,RootState>,languageId:string): Promise<any> {
    if (loadPromise) return loadPromise;
    porterBuilder.commitSetLanguageId(languageId);
    return loadPromise = new Promise((resolve, reject) => {

        porterBuilder.commitPorterItemsLoading();
        const client = ApiProvider.getApiClient();

        client.getPorterItems(languageId, porterBuilder.state.porterId).then(porterItems => {
            porterBuilder.commitPorterItemsLoaded(porterItems);
            loadPromise = null;
            resolve();
        }).catch(e => {
            loadPromise = null;
            porterBuilder.commitPorterError(e);
            reject(e);
        });
    });
}

async function createPorterItem(context:BareActionContext<PorterBuilderState,RootState>, args: CreatePorterItemCommandArguments) {
    const client = ApiProvider.getApiClient();
    return client.createPorterItem(args).then(res => {
        porterBuilder.dispatchLoadPorterItems(porterBuilder.state.languageId);
    }).catch(e => {
        porterBuilder.commitPorterError(e);
        throw "error";
    });
}

async function updatePorterItem(context:BareActionContext<PorterBuilderState,RootState>, args: UpdatePorterItemCommandArguments): Promise<void> {
    const client = ApiProvider.getApiClient();
    return client.updatePorterItem(args).then(res => {
    }).catch(e => {
        porterBuilder.commitPorterError(e);
        }
    );
}
async function deletePorterItem(context:BareActionContext<PorterBuilderState,RootState>,args:DeletePorterItemCommandArguments){
    const client = ApiProvider.getApiClient();
    client.deletePorterItem(args).then(res => {
        porterBuilder.dispatchLoadPorterItems(porterBuilder.state.languageId);
    }).catch(e => {
        porterBuilder.commitPorterError(e);
    });
}

async function initializePorterAction(context:BareActionContext<PorterBuilderState,RootState>):Promise<void>{
    if (!porterBuilder.state.porter) {
        if (!porterBuilder.state.porterId) {
            const porterId = Cookies.get("PorterBuilderId");
            porterBuilder.commitSetPorterId(porterId);
        }
        if(porterBuilder.state.porterId){
            const client = ApiProvider.getApiClient();
            return client.getPorterById(porterBuilder.state.porterId).then((porter) => {
                porterBuilder.commitInitializePorter(porter);
            }).catch((e) => {
                porterBuilder.commitPorterError(e);
            });
        }
    }
}

async function clearPorterAction(context:BareActionContext<PorterBuilderState,RootState>):Promise<any>{
    return new Promise((resolve) => {
        Cookies.remove("PorterBuilderId");
        porterBuilder.commitClearPorter();
        resolve();
    });
}

async function setModalItemNumberAction(context:BareActionContext<PorterBuilderState,RootState>,itemNo:string){
    porterBuilder.commitSetModalItemNumber(itemNo);
}

async function clearModalItemNumberAction(context:BareActionContext<PorterBuilderState,RootState>){
    porterBuilder.commitClearModalItemNumber();
}

const stateGetter = p.state();

const porterBuilder = {
    //State
    get state() {return stateGetter()},

    //Getters

    //Mutations
    commitSetPorterId: p.commit(setPorterId),
    commitSetLanguageId: p.commit(setLanguageId),
    commitPorterItemsLoading: p.commit(porterItemsLoading),
    commitPorterItemsLoaded: p.commit(porterItemsLoaded),
    commitPorterError: p.commit(porterError),
    commitInitializePorter: p.commit(initializePorter),
    commitClearPorter: p.commit(clearPorter),
    commitSetModalItemNumber: p.commit(setModalItemNumber),
    commitClearModalItemNumber: p.commit(clearModalItemNumber),

    //Actions
    dispatchSetPorterId: p.dispatch(setPorterIdAction),
    dispatchLoadPorterItems: p.dispatch(loadPorterItems),
    dispatchCreatePorterItem: p.dispatch(createPorterItem),
    dispatchUpdatePorterItem: p.dispatch(updatePorterItem),
    dispatchDeletePorterItem: p.dispatch(deletePorterItem),
    dispatchInitializePorter: p.dispatch(initializePorterAction),
    dispatchClearPorter: p.dispatch(clearPorterAction),
    dispatchSetModalItemNumber: p.dispatch(setModalItemNumberAction),
    dispatchClearModalItemNumber: p.dispatch(clearModalItemNumberAction)
}

export default porterBuilder;